import React, { useState } from "react";
import * as logger from "../../../shared/logger";

import RichText from "../../form-inputs/rich-text";

const RichTextExample = () => {
    const [textValue, setTextValue] = useState("<p><strong>Bold</strong> Super<sup>script</sup></p>");

    const updateField = (name, value) => {
        setTextValue(value);
        logger.log("reports back", name, value);
    };

    return <RichText name="richText" defaultValue={textValue} updateOnChange={updateField} />;
};

export default RichTextExample;
